<template>
  <el-dialog
    @update:modelValue="emit('update:modelValue', $event)"
    class="new_dialog"
    width="602px"
    title="所属省份"
    @open="openHandle"
  >
    <el-form
      ref="formRef"
      :model="formData"
      :rules="rules"
      hide-required-asterisk
      label-width="90px"
      label-position="left"
    >
      <el-form-item label="省份" prop="province">
        <el-select
          v-model="formData.province"
          placeholder="请选择"
          style="width: 100%"
          filterable
        >
          <el-option
            v-for="item in reactiveData.provinceList"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row justify="center">
        <el-button
          class="v2_btn"
          @click="submitForm(formRef)"
          :loading="loading"
        >
          确认
        </el-button>
      </el-row>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, toRefs, reactive } from 'vue'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import { province_change } from '@/utils/api'

const store = useStore()
const { state } = store
const { loading, userInfo } = toRefs(state)

const emit = defineEmits(['update:modelValue'])

const reactiveData = reactive({
  provinceList: [
    '北京',
    '天津',
    '上海',
    '重庆',
    '黑龙江',
    '吉林',
    '辽宁',
    '内蒙古',
    '宁夏',
    '甘肃',
    '新疆',
    '陕西',
    '山西',
    '山东',
    '河北',
    '河南',
    '西藏',
    '云南',
    '四川',
    '贵州',
    '广西',
    '广东',
    '福建',
    '湖南',
    '湖北',
    '江西',
    '浙江',
    '江苏',
    '安徽',
    '青海',
    '海南',
  ],
})

const formRef = ref()
const formData = reactive({
  province: '',
})
const default_rule = {
  message: '请输入',
}
const rules = reactive({
  province: [{ ...default_rule, required: true }],
})

const openHandle = () => {
  formData.province = userInfo.value.province
}

const submitForm = async (formEl) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
      province_change(formData).then(({ data: res }) => {
        ElMessage({
          type: 'success',
          message: res.info,
        })
        store.commit('userInfo', { ...userInfo.value, ...formData })
        emit('update:modelValue', false)
      })
    } else {
      console.log('error submit!', fields)
    }
  })
}
</script>

<style scoped lang="scss">
.v2_btn {
  min-width: 158px;
}
</style>
